import { 
    vanguard_icon,
    the_guardian,
    the_nations,
 } from "./assets"


const NewspaperData = [ 
    {
        id: 1,
        title: "'Nigeria is not broke' - Babatude Fashola",
        company: 'Vanguard',
        image: vanguard_icon,
        link: 'https://www.vanguardngr.com/2022/07/nigeria-is-not-broke-babatunde-fashola/',
    },
    
    {
        id: 2,
        title: 'Police recruitment based on merit, not politics, favouritism, says IGP',
        company: 'The Nations',
        image: the_nations,
        link: 'https://thenationonlineng.net/police-recruitment-based-on-merit-not-politics-favouritism-says-igp/',
    },

    {
        id: 3,
        title: '100m hurdles title: Tobi Amusan breaks down in tears while reciting Nigeria national anthem',
        company: 'Vanguard',
        image: vanguard_icon,
        link: 'https://www.vanguardngr.com/2022/07/100m-hurdles-title-tobi-amusan-breaks-down-in-tears-while-reciting-nigeria-national-anthem/',
    },


    {
        id: 4,
        title: 'Barcelona confident of beating Chelsea to Kounde’s signature',
        company: 'Guardian Newspaper',
        image: the_guardian,
        link: 'https://guardian.ng/sport/barcelona-confident-of-beating-chelsea-to-koundes-signature/',
    },

    {
        id: 5,
        title: 'Train attack: Shock as terrorists vow to kidnap Buhari, el-Rufai',
        company: 'Guardian Newspaper',
        image: the_guardian,
        link: 'https://guardian.ng/news/train-attack-shock-as-terrorists-vow-to-kidnap-buhari-el-rufai/',
    },

    {
        id: 6,
        title: 'FCT taskforce begins massive demolition of ‘illegal’ shops',
        company: 'The Nations',
        image: the_nations,
        link: 'https://thenationonlineng.net/fct-taskforce-begins-massive-demolition-of-illegal-shops/',
    },
    
]
    
    export {NewspaperData}